// Build-time feature flags. Defaults match the Poki / full-launch shape;
// the CrazyGames Basic-Launch build flips ADS_ENABLED via VITE_ADS_DISABLED
// because CG's SDK refuses ad requests during the 2-week quality-test phase.
//
// When ADS_ENABLED is false, callers should also hide bonus-token UI —
// tokens are only earnable by watching ads, so the entire token surface
// is dead weight without ads.

export const ADS_ENABLED = import.meta.env.VITE_ADS_DISABLED !== 'true';
